<p>shipping-label-settings works!</p>
